import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe transforms a date or string into the following format:
 * 1st May 2023 OR 3rd July 2023 etc
 */
@Pipe({ name: 'dateFormat', })
export class DateFormatPipe implements PipeTransform {
  transform(value: string | Date): string {
    if (!value) return '';

    const date = new Date(value);

    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();

    const daySuffix = this.getDaySuffix(day);

    return `${day}${daySuffix} ${month} ${year}`;
  }

  /**
   * Gets suffix for a day of the month
   * Returns 'st', 'nd', 'rd' or 'th'
   * @param day
   * @returns string
   */
  private getDaySuffix(day: number): string {
    const lastDigit = day % 10;

    // NB - 11, 12 and 13 and all 'th'
    if (lastDigit === 1 && day !== 11) {
      return 'st';
    }

    if (lastDigit === 2 && day !== 12) {
      return 'nd';
    }

    if (lastDigit === 3 && day !== 13) {
      return 'rd';
    }

    return 'th';
  }
}
